import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from './tooltip.directive';
import { FadeUpOnScrollDirective } from './app-fade-in.directive';
import { IntersectionObserverDirective } from './inrersection-observer.directive';


@NgModule({
  declarations: [
    TooltipDirective,
    FadeUpOnScrollDirective,
    IntersectionObserverDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [TooltipDirective, FadeUpOnScrollDirective, IntersectionObserverDirective],
})
export class AmyTooltipModuleModule { }
